import App from '@components/App'
import { useCallback, useEffect, useState } from 'react'

import { ChoicesProvider } from '@/contexts/choices'
import { ConfigProvider } from '@/contexts/config'
import { ConsultationProvider } from '@/contexts/consultation'
import { ErrorsProvider } from '@/contexts/error'
import { JourneyProvider } from '@/contexts/journey'
import { LoadingProvider } from '@/contexts/loading'
import { ModalProvider } from '@/contexts/modal'
import { StepperProvider } from '@/contexts/stepper'
import { UserProvider } from '@/contexts/user'
import { UserFormProvider } from '@/contexts/userForm'

export const Root = () => {
  const [error, setError] = useState('')
  if (error) throw error

  const promiseRejectionHandler = useCallback((event: PromiseRejectionEvent) => {
    setError(event.reason)
  }, [])

  useEffect(() => {
    window.addEventListener('unhandledrejection', promiseRejectionHandler)

    return () => {
      window.removeEventListener('unhandledrejection', promiseRejectionHandler)
    }
  }, [])

  return (
    <ConfigProvider>
      <ModalProvider>
        <UserProvider>
          <ChoicesProvider>
            <ErrorsProvider>
              <LoadingProvider>
                <JourneyProvider>
                  <StepperProvider>
                    <UserFormProvider>
                      <App />
                    </UserFormProvider>
                  </StepperProvider>
                </JourneyProvider>
              </LoadingProvider>
            </ErrorsProvider>
          </ChoicesProvider>
        </UserProvider>
      </ModalProvider>
    </ConfigProvider>
  )
}
